<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-100">
            <div class="media">
              <img src="/static/img/blue_2@3x.png"/>
              <div class="media-body">
                <h1>{{classInfo.class_name}}</h1>
                <div><span class="gray">과목</span> {{classInfo.cate_code_name}}  ·  <span class="gray">클래스 인원 </span> <span class="number">{{classInfo.class_user_cnt}}</span>  · <span class="gray">담당선생님</span> {{classInfo.class_manager_name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card second-card">
      <div class="card-body el-tabs__content">
        <div class="d-flex">
          <div class="p-2">
            <!-- <h2>성적분포</h2> -->
          </div>
        </div>

        <el-row :gutter="40">
          <el-col :span="11">
            <fieldset>
              <div class="d-flex">
                <div class="p-2">
                 <h2>커리큘럼 <span class="number mint">{{classBookTableData.length}}</span></h2>
                </div>
              </div>
              <stone-data-table
                table-ref="classExamTable"
                :columns="classBookTableColumns"
                :data="classBookTableData"
                :table-props="classBookTableProps"
                :current-row="currentRow"
                :loading="bookSearchLoading"
                :page-size="emptyPageSize"
                :pagination-props="emptyPaginationProps"
                @row-click="classBookRowClickHandler">
              </stone-data-table>
            </fieldset>
            <fieldset>
              <div class="d-flex">
                <div class="p-2">
                  <h2>시험 <span class="number mint">{{classExamTableData.length}}</span></h2>
                </div>
                <div class="ml-auto p-2">
                  <el-input-number size="small" v-model="minCount" :min="1" :max="classExamSelection.length"></el-input-number>
                  <button type="button" class="btn mint addUser-middle" :disabled="classExamSelection.length === 0" @click="retrieveExamClassUser">검색</button>
                </div>
              </div>
              <stone-data-table
                ref="classExamTable"
                table-ref="classExamTable"
                :columns="classExamTableColumns"
                :data="classExamTableData"
                :table-props="classExamTableProps"
                :loading="bookSearchLoading"
                :page-size="emptyPageSize"
                :pagination-props="emptyPaginationProps"
                @selection-change="handleExamSelectionChange"
                @row-click="classExamRowClickHandler">
              </stone-data-table>
            </fieldset>
          </el-col>
          <el-col :span="13">
            <fieldset>
              <div class="d-flex">
                <div class="p-2">
                  <h2>응시 인원 <span class="number mint">{{classUserData.length}}</span><span v-if="filterDataCount > 0 && filterDataCount !== classUserData.length" class="number mint"> ({{filterDataCount}})</span></h2>
                </div>
                <div class="ml-auto p-2">
                  <!-- <button type="button" class="btn mint addUser-middle" @click="testFilter">Test</button> -->
                  <button type="button" class="btn mint addUser-middle" :disabled="classUserSelection.length === 0" @click="sendGrade">성적표 알림톡 보내기</button>
                  <excel :name="btnExcelName" @click="downloadExcel" :loading="excelLoading" :disabled="classUserData.length === 0"></excel>
                </div>
              </div>
              <data-tables
                ref="classUserTable"
                class="no-left-margin small-td"
                :data="classUserData"
                :table-props="classUserTableProps"
                :page-size="emptyPageSize"
                :pagination-props="emptyPaginationProps"
                @selection-change="handleSelectionChange"
                @filter-change="handleFilterChange"
                @row-click="classUserRowClickHandler"
                v-loading="classSearchLoading">
                <el-table-column v-for="(column, index) in classUserColumns" :key="'row_' + index" v-if="column.prop !== 'times_history'"
                  :type="column.type" :prop="column.prop" :label="column.label" :align="column.align" :width="column.width" :sortable="column.sort" :formatter="column.formatter"
                  header-align="center" label-class-name="stone-table-label">
                </el-table-column>
                <el-table-column label="응시회차" header-align="center" align="left" min-width="150" prop="times_history"
                  :filters="filterTimes"
                  :filter-method="filterTimesHandler"
                  :filtered-value="filterTimesValue"
                  filter-placement="bottom-end">
                  <template slot-scope="scope">
                    <el-tag v-for="(time, index) in scope.row.times_history.split(',')" :key="'tag_' + index" size="small" style="margin-left: 4px;" disable-transitions>{{time}}</el-tag>
                  </template>
                </el-table-column>
              </data-tables>
            </fieldset>
          </el-col>
        </el-row>

      </div>
    </div>

    <el-dialog title="종합 성적표" width="1230px" :visible.sync="dialogTableVisible" append-to-body>
      <div class="card-body text-right">
        <el-button class="pdf circle" type="primary" :loading="pdfLoading" @click="handlePDF"><i class="fas fa-file-pdf"></i></el-button>
      </div>
      <R010202 ref="printDialog" :is-create="false"></R010202>
    </el-dialog>

  </div>
</template>

<script>

import common from '@/modules/common'
import R010202 from './R010202.vue'

export default {
  name: 'M060402',
  components: {R010202},
  mixins: [common.mixins],
  data () {
    return {
      classInfo: {
        class_seq: 0,
        cate_code: '',
        cate_code_name: '',
        class_name: '',
        class_manager: '',
        class_manager_name: '',
        class_user_cnt: 0,
        memo: '',
        use_yn: 'Y',
        class_user: []
      },
      classUserTableProps: {height: this.getScreenHeight(70)},
      classUserData: [],
      classUserColumns: [
        {label: '', prop: 'chk', align: 'center', type: 'selection'},
        {label: 'No', align: 'center', type: 'index', width: 50},
        {label: '이름', prop: 'user_name', align: 'center', width: 120},
        {label: '전화번호', prop: 'phone', align: 'center', width: 140, formatter: this.columnFormatterPhone, dataType: 'phone'},
        {label: '점수', prop: 'exam_score_total', align: 'right', width: 70},
        {label: '석차', prop: 'exam_rank', align: 'right', width: 70},
        {label: '응시회차', prop: 'times_history', align: 'left', width: 150}
      ],
      classBookTableProps: {height: this.getScreenHeight(510), highlightCurrentRow: true},
      classBookTableData: [],
      classBookTableColumns: [
        {label: 'No', align: 'center', type: 'index', width: 50},
        // {label: '교재번호', prop: 'book_seq', align: 'center', width: 100},
        {label: '커리큘럼명', prop: 'book_name', align: 'left', width: 200}
      ],
      bookSearchLoading: false,
      examSearchLoading: false,
      classSearchLoading: false,
      currentRow: null,
      classUserSelection: [],
      classExamTableProps: {height: this.getScreenHeight(308), highlightCurrentRow: true},
      classExamTableData: [],
      classExamTableColumns: [
        {label: '', prop: 'chk', align: 'center', type: 'selection'},
        {label: 'No', align: 'center', type: 'index', width: 50},
        {label: '시험명', prop: 'exam_title', align: 'left', width: 200},
        {label: '회차', prop: 'times_name', align: 'center', width: 60},
        {label: '응시인원', prop: 'entry_cnt', align: 'right', formatter: this.columnFormatterNumber, width: 70, sortable: false},
        {label: '종료일자', prop: 'close_dt', align: 'center', formatter: this.columnFormatterDate, width: 80, sortable: false}
      ],
      dialogTableVisible: false,
      pdfLoading: false,
      selectionExamTimes: 1,
      filterTimesValue: [],
      classExamSelection: [],
      minCount: 1,
      filterDataCount: 0
    }
  },
  beforeCreate () {
    if (this.$route.params.class_seq === undefined || this.$route.params.class_seq === 0) {
      this.$router.push({name: 'M060201'})
    }
  },
  created () {
    const classSeq = this.$route.params.class_seq
    this.loadInfo(classSeq)
    this.retrieveClassExamBook(classSeq)
  },
  computed: {
    filterTimes () {
      const times = []
      this.classExamSelection.forEach(item => {
        times.push({ text: item.times + '회차', value: item.times + '' })
      })
      if (times.length === 0) {
        times.push({ text: '1회차', value: '1' })
      }
      return times
    }
  },
  mounted () {
  },
  methods: {
    // 클래스 정보 조회
    loadInfo (classSeq) {
      common.axios.get('/class/info/' + classSeq)
        .then(response => {
          const result = response.data
          Object.keys(this.classInfo).forEach(key => {
            this.classInfo[key] = result[key]
          })
        })
    },
    retrieveClassExamBook (classSeq) {
      this.bookSearchLoading = true
      common.axios.post('/grade/class/book', {class_seq: classSeq})
        .then(response => {
          this.bookSearchLoading = false
          this.classBookTableData = response.data
        })
        .catch(() => {
          this.bookSearchLoading = false
        })
    },
    retrieveExamClassUser () {
      this.clearDataTables()
      this.classSearchLoading = true
      const param = {
        book_seq: this.currentRow.book_seq,
        class_seq: this.classInfo.class_seq,
        exams: this.classExamSelection,
        min_count: this.minCount
      }
      // console.log('param : ', param)
      common.axios.post('/grade/book/class/user', param)
        .then(response => {
          this.classSearchLoading = false
          this.classUserData = response.data
        })
        .catch(() => {
          this.classSearchLoading = false
        })
    },
    retrieveExam (param) {
      this.selectionExamTimes = 0
      this.examSearchLoading = true
      common.axios.post('/grade/book/exam', {book_seq: param.book_seq, class_seq: param.class_seq})
        .then(response => {
          this.examSearchLoading = false
          this.classExamTableData = response.data
        })
        .catch(() => {
          this.examSearchLoading = false
        })
    },
    classUserRowClickHandler (row) {
      this.dialogTableVisible = true
      this.$nextTick(() => {
        this.$refs.printDialog.initGradeTotal(row)
      })
      // this.$router.push({name: 'M060303', params: row})
    },
    classBookRowClickHandler (row) {
      this.currentRow = row
      this.clearDataTables(true)
      this.$nextTick(() => {
        this.retrieveExam(row)
      })
    },
    classExamRowClickHandler (row) {
      this.handleTableSelectionToggle('classExamTable', row)
    },
    clearDataTables (isExam = false) {
      if (isExam) {
        this.classExamTableData = []
        this.selectionExamTimes = 1
      }
      this.filterDataCount = 0
      this.classUserData = []
      this.$refs.classUserTable.$refs.elTable.clearFilter()
      this.$refs.classUserTable.$refs.elTable.clearSort()
    },
    handleSelectionChange (value) {
      this.classUserSelection = value
    },
    handleFilterChange (filters) {
      this.filterDataCount = this.$refs.classUserTable.$refs.elTable.tableData.length
    },
    sendGrade () {
      this.$confirm('종합성적표 알림톡을 발송하시겠습니까?', '', {})
        .then(() => {
          this.classUserSelection.map(x => {
            x.class_name = this.classInfo.class_name
            x.class_user_name = x.user_name
          })
          common.axios.post('/exam/kakao/grade/total', {seq: this.currentRow.book_seq, title: this.currentRow.book_name, users: this.classUserSelection})
            .then(response => {
              const result = response.data
              if (result.status === 1) {
                this.$message('종합성적표가 발송되었습니다.')
                const dataTable = this.$refs.classUserTable.$refs.classUserTable.$refs.elTable
                this.classUserSelection.forEach(row => {
                  dataTable.toggleRowSelection(row, false)
                })
                this.classUserSelection = []
              } else {
                this.$message.warning(result.message)
              }
            })
        })
        .catch(() => {})
    },
    handlePDF () {
      this.pdfLoading = true
      this.$refs.printDialog.handlePDF()
    },
    completedPDF (isSuccess) {
      this.pdfLoading = false
      if (!isSuccess) {
        this.$message.error('PDF 생성에 실패하였습니다.')
      }
    },
    filterTimesHandler (value, row, column) {
      const filters = this.$refs.classUserTable.$refs.elTable.columns[6].filteredValue.sort()
      const times = row.times_history.split(',')
      return this.arrayContainsArray(times, filters)
    },
    arrayContainsArray (superset, subset) {
      if (subset.length === 0) {
        return false
      }
      // return subset.every(value => superset.indexOf(value) >= 0)
      // return superset.length === subset.length && superset.every(value => subset.indexOf(value) >= 0)
      return superset.length === subset.length && superset.every((value, index) => value === subset[index])
    },
    handleExamSelectionChange (value) {
      value.sort((a, b) => {
        return a.times < b.times ? -1 : (a.times > b.times ? 1 : 0)
      })
      this.classExamSelection = value
      this.minCount = value.length
    },
    downloadExcel () {
      const param = {
        data: {
          service: 'ExamService',
          method: 'selectBookClassExamUserList',
          params: {
            book_seq: this.currentRow.book_seq,
            class_seq: this.classInfo.class_seq,
            exams: this.classExamSelection,
            min_count: this.minCount
          }
        },
        excel: {
          columns: this.classUserColumns,
          file: '종합성적표_' + this.classInfo.class_name + '_' + this.classExamSelection[0].book_name
        }
      }
      // 필터 데이터가 있을 경우에는 필터 데이터만 담아서 보낸다.
      if (this.filterDataCount > 0 && this.filterDataCount !== this.classUserData.length) {
        param.excel.data = this.$refs.classUserTable.$refs.elTable.tableData
      }
      this.exportExcel(param)
    },
    testFilter () {
      console.log('elTable : ', this.$refs.classUserTable.$refs.elTable.tableData.length)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/M060402.vue